import React from 'react'
import { Form } from 'semantic-ui-react'
import RichTextEditor from '../../RichTextEditor'
import Metadata from '../Metadata'

const details = ({obj, language, onChange}) => {
  return (
    <div>
      <Form.Field>
        <Form.Input label='Titre' placeholder="Titre" id="title" value={obj.translations[language.code].title} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Field>
        <label>Contenu</label>
        <RichTextEditor id='content' value={obj.translations[language.code].content} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Group widths='equal'>
        <Form.Input placeholder='Label du bouton' id='cta_label' fluid label='Label du bouton' value={obj.translations[language.code].cta_label} onChange={(e) => onChange(e, language.code)} />
        <Form.Input placeholder='https://...' id='cta_url' fluid label='Adresse cible' value={obj.translations[language.code].cta_url} onChange={(e) => onChange(e, language.code)} />
      </Form.Group>
      <Form.Group widths='equal'>
        <Form.Input placeholder='Label du bouton Push' id='push_cta_label' fluid label='Label du bouton Push' value={obj.translations[language.code].push_cta_label} onChange={(e) => onChange(e, language.code)} />
        <Form.Input placeholder='https://...' id='push_cta_url' fluid label='Adresse cible' value={obj.translations[language.code].push_cta_url} onChange={(e) => onChange(e, language.code)} />
      </Form.Group>
      <Metadata obj={obj} language={language} onChange={onChange} />
    </div>
  )
}

export default details



// WEBPACK FOOTER //
// ./src/components/form/pressKit/details.js